export const GET_ALL_FORMS = "GET_ALL_FORMS";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_DYNAMIC_FORMS = "START_LOADING_DYNAMIC_FORMS";
export const STOP_LOADING_DYNAMIC_FORMS = "STOP_LOADING_DYNAMIC_FORMS";
export const ERROR_LOADING_DYNAMIC_FORMS = "ERROR_LOADING_DYNAMIC_FORMS";